// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.master-example-row {
    background-color: inherit;
    cursor: pointer;
}

.master-example-row-content {
    padding: 8px 8px 8px 20px;
}

.master-example-scroll-container {
    max-height: 200px;
    width: 100%;
}

@media screen and (max-width: 1023px) {
    .single-layer-details {
        max-width: 150px;
    }

    .master-example-panel.flex-noshrink {
        flex-shrink: 1;
    }
}

.single-layer-details-contents {
    font-size: 18px;
    margin-left: 12px;
}

.description-primary-text.secondary-text,
.bolt-master-panel-header-subtitle.secondary-text {
    color: inherit;
}

@media screen and (max-width: 800px) {
    .context-details {
        max-width: 320px;
    }
}

.details-view-title {
    white-space: normal;
}

.bolt-master-panel-header-title {
    white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/Docs/Components/MasterDetail/examples/MasterDetail.Example.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".master-example-row {\r\n    background-color: inherit;\r\n    cursor: pointer;\r\n}\r\n\r\n.master-example-row-content {\r\n    padding: 8px 8px 8px 20px;\r\n}\r\n\r\n.master-example-scroll-container {\r\n    max-height: 200px;\r\n    width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n    .single-layer-details {\r\n        max-width: 150px;\r\n    }\r\n\r\n    .master-example-panel.flex-noshrink {\r\n        flex-shrink: 1;\r\n    }\r\n}\r\n\r\n.single-layer-details-contents {\r\n    font-size: 18px;\r\n    margin-left: 12px;\r\n}\r\n\r\n.description-primary-text.secondary-text,\r\n.bolt-master-panel-header-subtitle.secondary-text {\r\n    color: inherit;\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n    .context-details {\r\n        max-width: 320px;\r\n    }\r\n}\r\n\r\n.details-view-title {\r\n    white-space: normal;\r\n}\r\n\r\n.bolt-master-panel-header-title {\r\n    white-space: normal;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
